import React from "react";
import TrailTable from "components/common/TrailTable/TrailTable";

interface Props {
  entityId: string;
}

const PromoTrailTab: React.FC<Props> = ({ entityId }) => {
  return <TrailTable entityType="promo" entityId={Number(entityId)} />;
};

export default PromoTrailTab;
